import { render, staticRenderFns } from "./DeletedUserList.vue?vue&type=template&id=7aa89164&"
import script from "./DeletedUserList.vue?vue&type=script&lang=js&"
export * from "./DeletedUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports